import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        console.log("Dependent select controller connected");
        // The form element is the controller root (mount it on #myForm)
        this.form = this.element;

        // Read JSON from data attribute
        const raw = this.form.dataset.dependentSelects;
        this.dependentSelectsData = raw ? JSON.parse(raw) : {};

        this.dependentFields = Array.from(
            this.form.querySelectorAll("select[data-dependent-on]")
        );

        // Bind handlers per dependent select (store refs so they can be removed on disconnect)
        this._handlers = [];

        for (const select of this.dependentFields) {
            const parentId = select.dataset.dependentOn;
            const parentField = this.form.querySelector(`select#${CSS.escape(parentId)}`);

            if (!parentField) continue;

            const handler = () => this.updateDependentSelect(select, parentField.value);
            parentField.addEventListener("change", handler);
            this._handlers.push([parentField, handler]);

            // Initial hydration (in case parent already has a value)
            this.updateDependentSelect(select, parentField.value);
        }
    }

    disconnect() {
        // Cleanup to avoid duplicate listeners under Turbo
        for (const [parentField, handler] of this._handlers || []) {
            parentField.removeEventListener("change", handler);
        }
        this._handlers = [];
    }

    updateDependentSelect(dependentSelect, parentValue) {
        const fieldName = dependentSelect.id;

        const defaultMessage =
            dependentSelect.getAttribute("data-dependent-on-message") || "Please select";

        if (!parentValue) {
            dependentSelect.innerHTML = `<option value="">${defaultMessage}</option>`;
            dependentSelect.disabled = true;
            return;
        }

        const newOptions = this.getNewOptionsForDependentField(fieldName, parentValue);

        dependentSelect.innerHTML = newOptions
            .map((option) => `<option value="${option.value}">${option.display_text}</option>`)
            .join("");

        dependentSelect.disabled = false;

        // Keep your behavior: trigger combination checker / validations
        dependentSelect.dispatchEvent(new InputEvent("input", { bubbles: true }));
    }

    getNewOptionsForDependentField(fieldName, parentValue) {
        const optionsMap = this.dependentSelectsData[fieldName];

        if (optionsMap?.[parentValue]) {
            // Your original comment says array-of-arrays; implement defensively.
            // If it's actually an array of objects, adjust here.
            return optionsMap[parentValue].map((opt) => {
                // Support both shapes:
                // - [value, display_text]
                // - { value: "...", display_text: "..." }
                if (Array.isArray(opt)) {
                    const [value, display_text] = opt;
                    return { value: value ?? "", display_text: display_text ?? "Invalid option" };
                }
                return {
                    value: opt?.value ?? "",
                    display_text: opt?.display_text ?? "Invalid option",
                };
            });
        }

        return [{ value: "", display_text: defaultMessageForMissing() }];
        function defaultMessageForMissing() {
            return "Please select";
        }
    }
}
